import ApiClient from "@/api/index";
import { LoginResponseType, RegisterRequestType, VerifyEmailRequestType, VerifyEmailResponseType } from "@/api/auth/types";

export class Auth {
  static login(email: string, password: string): Promise<LoginResponseType> {
    return ApiClient.post("/auth/login", { email, password });
  }

  static register(data: RegisterRequestType): Promise<void> {
    return ApiClient.post("/auth/register", data);
  }

  static resendVerification(email: string): Promise<void> {
    return ApiClient.post("/auth/resend-verification", { email });
  }

  static verifyEmail(data: VerifyEmailRequestType): Promise<VerifyEmailResponseType> {
    return ApiClient.post("/auth/verify-email", data);
  }

  static logout(): Promise<void> {
    return ApiClient.post("/auth/logout");
  }
}
